import { useResolvedBreadcrumbTitle } from "@/common/hooks/resolve-breadcrumb-title/use-resolved-breadcrumb-title";
import { recentVisitsStore } from "@/store/recent-visits/recent-visits-store";
import { useEffect } from "react";
import { useLocation } from "wouter";

const EXCLUDED_PATHS = new Set(["/", "/home"]);

export function useTrackRecentVisit(): void {
  const [location] = useLocation();
  const title = useResolvedBreadcrumbTitle(location);
  const addVisit = recentVisitsStore((state) => state.addVisit);

  useEffect(() => {
    if (!title || EXCLUDED_PATHS.has(location)) return;
    addVisit({ path: location, title });
  }, [location, title, addVisit]);
}
